export var HorizontalOrigin;
(function (HorizontalOrigin) {
    HorizontalOrigin["LEFT"] = "left";
    HorizontalOrigin["CENTER"] = "center";
    HorizontalOrigin["RIGHT"] = "right";
})(HorizontalOrigin || (HorizontalOrigin = {}));
export var VerticalOrigin;
(function (VerticalOrigin) {
    VerticalOrigin["TOP"] = "top";
    VerticalOrigin["CENTER"] = "center";
    VerticalOrigin["BOTTOM"] = "bottom";
})(VerticalOrigin || (VerticalOrigin = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUG9wb3ZlclR5cGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiUG9wb3ZlclR5cGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBTixJQUFZLGdCQUlYO0FBSkQsV0FBWSxnQkFBZ0I7SUFDMUIsaUNBQWEsQ0FBQTtJQUNiLHFDQUFpQixDQUFBO0lBQ2pCLG1DQUFlLENBQUE7QUFDakIsQ0FBQyxFQUpXLGdCQUFnQixLQUFoQixnQkFBZ0IsUUFJM0I7QUFFRCxNQUFNLENBQU4sSUFBWSxjQUlYO0FBSkQsV0FBWSxjQUFjO0lBQ3hCLDZCQUFXLENBQUE7SUFDWCxtQ0FBaUIsQ0FBQTtJQUNqQixtQ0FBaUIsQ0FBQTtBQUNuQixDQUFDLEVBSlcsY0FBYyxLQUFkLGNBQWMsUUFJekIifQ==